export enum ConnectionFactoryType {
    RdpConnection = 0,
    MockConnection = 1,
    MockDefectConnection = 2
}
